export enum SlateSource {
  USER_DICTATION = 'user/dictation',
  USER_KEYBOARD = 'user/keyboard',
  UGC_TEMPLATE = 'ugc/template',
  UGC_MACRO = 'ugc/macro',
  UGC_PICKLIST = 'ugc/picklist',
  AI_TEMPLATE_MAPPER = 'ai/template-mapper',
  AI_IMAGE_BOOKMARK = 'ai/image-bookmark',
}

export const slateSource = Object.freeze({
  user: {
    dictation: SlateSource.USER_DICTATION,
    keyboard: SlateSource.USER_KEYBOARD,
  },
  ugc: {
    template: SlateSource.UGC_TEMPLATE,
    macro: SlateSource.UGC_MACRO,
    picklist: SlateSource.UGC_PICKLIST,
  },
  ai: {
    imageBookmark: SlateSource.AI_IMAGE_BOOKMARK,
    // TODO: We need to update this to more granular ai options some day, but for purposes of focus mode for
    // RSNA, we'll be using the pre-existing ai/template-mapper
    impressionGenerator: SlateSource.AI_TEMPLATE_MAPPER,
    focusMode: SlateSource.AI_TEMPLATE_MAPPER,
  },
});
